/**
 * inputPasswordDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function inputPasswordDirective() {
    return {
        template: `
            <md-input-container>
                <label>{{ label }}</label>
                <input type="password"
                       name="{{ name || '' }}"
                       ng-model="value"
                       ng-disabled="disabled"
                       ng-required="required">

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-message="custom">{{ form[name].customError }}</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-input-container>
        `,
        scope: {
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            label: '@label',
            name: '@name',
            required: '=?required',
            value: '=value',
        },
        link: function(scope, element, attrs) {
            element.addClass('app-form-field');

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }
        },
    };
}
